/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Enforcement_TextInputs */

const en_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If we do not respond satisfactorily to your request, you can contact the responsible market surveillance authority:`)
};

const de_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollten wir auf Ihre Anfrage nicht zufriedenstellend reagieren, können Sie sich an die zuständige Marktüberwachungsbehörde wenden:`)
};

const fr_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si nous ne repondons pas de maniere satisfaisante a votre demande, vous pouvez contacter l'autorite de surveillance du marche responsable :`)
};

const es_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si no respondemos satisfactoriamente a su solicitud, puede contactar a la autoridad de vigilancia del mercado responsable:`)
};

const it_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se non rispondiamo in modo soddisfacente alla tua richiesta, puoi contattare l'autorita di sorveglianza del mercato responsabile:`)
};

const nl_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als wij niet naar tevredenheid op uw verzoek reageren, kunt u contact opnemen met de verantwoordelijke markttoezichtautoriteit:`)
};

const pl_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesli nie odpowiemy w sposob satysfakcjonujacy na Twoje zadanie, mozesz skontaktowac sie z wlasciwym organem nadzoru rynku:`)
};

const fi_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos emme vastaa tyydyttävästi pyyntöösi, voit ottaa yhteyttä vastuulliseen markkinavalvontaviranomaiseen:`)
};

const da_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis vi ikke svarer tilfredsstillende pa din anmodning, kan du kontakte den ansvarlige markedsovervagningsmyndighed:`)
};

const sv_a11y_statement_enforcement_text = /** @type {(inputs: A11y_Statement_Enforcement_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om vi inte svarar pa ett tillfredsstellande satt pa din forfragan kan du kontakta ansvarig marknadstillsynsmyndighet:`)
};

/**
* | output |
* | --- |
* | "If we do not respond satisfactorily to your request, you can contact the responsible market surveillance authority:" |
*
* @param {A11y_Statement_Enforcement_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_enforcement_text = /** @type {((inputs?: A11y_Statement_Enforcement_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Enforcement_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_enforcement_text(inputs)
	if (locale === "fr") return fr_a11y_statement_enforcement_text(inputs)
	if (locale === "es") return es_a11y_statement_enforcement_text(inputs)
	if (locale === "it") return it_a11y_statement_enforcement_text(inputs)
	if (locale === "nl") return nl_a11y_statement_enforcement_text(inputs)
	if (locale === "pl") return pl_a11y_statement_enforcement_text(inputs)
	if (locale === "fi") return fi_a11y_statement_enforcement_text(inputs)
	if (locale === "da") return da_a11y_statement_enforcement_text(inputs)
	if (locale === "sv") return sv_a11y_statement_enforcement_text(inputs)
	return en_a11y_statement_enforcement_text(inputs)
});